import type SideBarData from "@ext/git/actions/Publish/model/SideBarData";
import { create } from "zustand";

interface DiffViewModeState {
	sideBarData: SideBarData;
	resourceDiffEnabled: boolean;
	sourceTextLocked: boolean;
	updateResourceDiffEnabled: (enabled: boolean) => void;
	updateSourceTextLocked: (locked: boolean) => void;
	updateSideBarData: (sideBarData: SideBarData) => void;
}

const useDiffViewModeStore = create<DiffViewModeState>()((set) => ({
	sideBarData: null,
	resourceDiffEnabled: false,
	sourceTextLocked: false,
	updateResourceDiffEnabled: (enabled: boolean) => set({ resourceDiffEnabled: enabled }),
	updateSourceTextLocked: (locked: boolean) => set({ sourceTextLocked: locked }),
	updateSideBarData: (sideBarData: SideBarData) => set({ sideBarData: sideBarData }),
}));

export const useSideBarData = () => useDiffViewModeStore((state) => state.sideBarData);

export const setSideBarData = (sideBarData: SideBarData) => {
	useDiffViewModeStore.getState().updateSideBarData(sideBarData);
};

export const useResourceDiffEnabled = () => useDiffViewModeStore((state) => state.resourceDiffEnabled);

export const setDiffEnabled = (enabled: boolean) => {
	useDiffViewModeStore.getState().updateResourceDiffEnabled(enabled);
};

export const useSourceTextLocked = () => useDiffViewModeStore((state) => state.sourceTextLocked);

export const setSourceTextLocked = (locked: boolean) => {
	useDiffViewModeStore.getState().updateSourceTextLocked(locked);
};
